<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page APP_SalesReport002
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – namnth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapMutations, mapState, mapActions } from 'vuex';
import store from '@/store';
import APP_SalesReport002_store from '@/views/mobile/app_sales_report/APP_SalesReport002/store';
import PopupSystem001 from '@/views/popupSearch/PopupSystem001/store';
import PopupMST001 from '@/views/popupSearch/PopupMST001/store';
import PopupMST002 from '@/views/popupSearch/PopupMST002/store';
import PopupMST005 from '@/views/popupSearch/PopupMST005/store';
import template from './template.html';
import './style.scss';
import messages, { MSG_BUTTON, MSG_TITLE, MSG_TYPE } from '@/utils/messages';
import helpers from '@/utils/helpers';
import repository from './repository';
import MNG_WorkReport002_store from '@/views/move/mng_workreport/MNG_WorkReport002/store';

var APP_SalesReport002 = {
    template: template,
    props: {
        typeSelected: {
            type: Number,
            default: 1
        },
        checkTab: {
            type: Number,
            default: 0
        },
        mode: {
            type: Number,
            default: 0
        },
        tabId: {
            type: [String, Number],
            required: false,
            default: null
        },
        arrayItem: {
            type: Object,
            default: () => ({})
        }
    },
    beforeCreate() {
        if (!store.hasModule('APP_SalesReport002')) {
            store.registerModule('APP_SalesReport002', APP_SalesReport002_store);
        }
        if (!store.hasModule('MNG_WorkReport002')) {
            store.registerModule('MNG_WorkReport002', MNG_WorkReport002_store);
        }
        if (!store.hasModule('PopupSystem001')) {
            store.registerModule('PopupSystem001', PopupSystem001);
        }
        if (!store.hasModule('PopupMST001')) {
            store.registerModule('PopupMST001', PopupMST001);
        }
        if (!store.hasModule('PopupMST002')) {
            store.registerModule('PopupMST002', PopupMST002);
        }
        if (!store.hasModule('PopupMST005')) {
            store.registerModule('PopupMST005', PopupMST005);
        }
    },
    created() {
        if (this.tabId) {
            this.localData = this.listPlace.find((item) => item.id == this.tabId);
            const client_staff = this.localData.client_staff || [];
            client_staff.forEach((item) => {
                this.ensureRowUid(item, 'tab');
                item.disable = { StartDate: !!item.StartDate, StaffName: !!item.StaffName, Remarks: !!item.Remarks };
                item.showImage = false;
                item.imageSrc = '#';
            });
            this.$nextTick(() => {
                this.localData.client_staff.forEach((item, index) => {
                    if (item.FilePath) {
                        this.loadImageFromPath(item, index);
                    }
                });
            });
            return;
        }
        this.setScreenId(this.screenId);
        this.setHeader(this.header);
        this.applyLoginCompanyFilter();
        this.applyArrayItem(this.arrayItem);
    },
    mounted() {},
    unmounted() {},
    data() {
        return {
            screenId: 'APP_SalesReport002',
            liftedIndex: null,
            holdTimer: null,
            deleteTimer: null,
            selectedIndex: null,
            localData: null,
            rowUidSeed: 0,
            lastTouchStartAt: 0,
            isTouchInteraction: false,
            isDeleteModalOpening: false
        };
    },
    emits: ['emitHideDetail'],
    watch: {
        typeSelected(newVal) {
            this.realData.type = newVal;
            this.changeType();
        },
        arrayItem: {
            deep: true,
            handler(newVal) {
                if (this.tabId) return;
                this.applyArrayItem(newVal);
            }
        }
    },
    computed: {
        ...mapState('app', ['user']),
        ...mapState('APP_SalesReport002', ['optionGroup', 'data', 'paginationData']),
        ...mapState('MNG_WorkReport002', { listPlace: (state) => state.data.sites }),
        isEditMode() {
            return Number(this.mode) === 1;
        },
        loginCompanyCd() {
            const companyCd = Number(this.user?.company_cd);
            return Number.isNaN(companyCd) ? null : companyCd;
        },
        isCompanyEditable() {
            return this.loginCompanyCd === null || this.loginCompanyCd === 99;
        },
        canSubmit() {
            const companyCd = String(this.realData?.company_cd || '').trim();
            const mdcd = Number(this.realData?.mdcd || 0);
            const clientCd = this.realData?.client_cd || '';
            const branchCd = String(this.realData?.branch_cd || '').trim();
            return Boolean(companyCd) && mdcd > 0 && Boolean(clientCd) && Boolean(branchCd) && !this.hasInvalidPurchasingPeople();
        },
        header() {
            return {
                title: '営業報告詳細',
                topButtons: []
            };
        },
        realData() {
            return this.tabId ? this.localData : this.data;
        }
    },
    methods: {
        ...mapMutations('app', [
            'showHeaderError',
            'setScreenId',
            'setHeader',
            'setNotification',
            'showModalMessage',
            'hideModalMessage',
            'hideHeaderError'
        ]),
        ...mapMutations('APP_SalesReport002', ['resetFormData', 'initForm']),
        ...mapActions('MNG_WorkReport002', ['searchPastSalesReport']),
        ...mapActions('PopupSystem001', ['searchSystemInfo']),
        ...mapActions('PopupMST001', ['searchMst001Info']),
        ...mapActions('PopupMST002', ['searchMst002Info']),
        ...mapActions('PopupMST005', ['searchAreaInfo']),
        generateRowUid(prefix = 'r') {
            this.rowUidSeed += 1;
            return `${prefix}_${Date.now()}_${this.rowUidSeed}`;
        },
        ensureRowUid(item, prefix = 'r') {
            if (!item) return '';
            if (!item.__row_uid) {
                item.__row_uid = this.generateRowUid(prefix);
            }
            return item.__row_uid;
        },
        async loadImageFromPath(item, index) {
            try {
                const rawPath = item.FilePath;
                const repository = await import('./repository');
                const res = await repository.default.getImage(rawPath, this.localData.CompanyCD, 12);

                const img = this.$refs[`imagePreview_${index}`];
                if (res.status === 200 && img) {
                    if (res.data.size > 0) {
                        const blob = res.data;
                        const objectUrl = URL.createObjectURL(blob);

                        item.imageSrc = objectUrl;
                        item.showImage = true;

                        img.src = objectUrl;
                    } else {
                        item.imageSrc = '#';
                        item.showImage = false;
                        img.src = '#';
                    }
                }
            } catch (error) {
                console.error('loadImageFromPath error:', error);

                const img = this.$refs[`imagePreview_${index}`];
                item.imageSrc = '#';
                item.showImage = false;

                if (img) {
                    img.src = '#';
                }
            }
        },
        clearDepartmentInfo() {
            this.realData.mdcd = 0;
            this.realData.md_name = '';
        },
        clearBranchInfo() {
            this.realData.branch_cd = '';
            this.realData.branch_nm = '';
        },
        resetDetailBody() {
            this.realData.work_report_id = 0;
            this.realData.tab_no = 1;
            this.realData.visit_date = '';
            this.realData.report_date = '';
            this.realData.report_content = '';
            this.realData.reporting_filename = '';
            this.realData.reporting_file = '';
            this.realData.sales_matter_content = [];
            this.realData.purchasing_people = [
                {
                    __row_uid: this.generateRowUid('pp'),
                    staff_detail_no: 0,
                    no: '',
                    start_date: '',
                    person_in_charge: '',
                    filename: '',
                    file_path: '',
                    file: '',
                    note: '',
                    showImage: false,
                    imageSrc: '#',
                    disable: { start_date: false, person_in_charge: false, note: false }
                }
            ];
            this.realData.visit_reports = [];
            this.paginationData.pageNo = 1;
            this.paginationData.totalRows = 0;
            this.paginationData.msgNoData = '該当するデータが存在しません。';
        },
        tryLoadByCurrentKey() {
            const companyCd = String(this.realData.company_cd || '').trim();
            const clientCd = String(this.realData.client_cd || '').trim();
            const branchCd = String(this.realData.branch_cd || '').trim();
            if (!companyCd || !this.isValidClientCd(clientCd) || !branchCd) {
                this.resetDetailBody();
                return;
            }
            this.referByClientCd(clientCd, companyCd);
        },
        applyLoginCompanyFilter() {
            // Keep company blank on open as requested.
        },
        referCompany(index, value) {
            const previousCompanyCd = String(this.realData.company_cd || '').trim();
            const clearDependentFields = () => {
                this.clearDepartmentInfo();
                this.realData.client_cd = '';
                this.realData.client_nm = '';
                this.clearBranchInfo();
                this.resetDetailBody();
            };
            if (!value) {
                this.realData.company_cd = '';
                this.realData.company_nm = '';
                clearDependentFields();
                return;
            }
            this.searchSystemInfo({
                company_cd: value,
                mode: 1,
                callback: (response) => {
                    if (response?.Data?.data?.length > 0) {
                        const result = response.Data.data[0];
                        this.realData.company_cd = result.company_cd;
                        this.realData.company_nm = result.company_name;
                        if (previousCompanyCd && previousCompanyCd !== String(result.company_cd)) {
                            clearDependentFields();
                        } else {
                            this.tryLoadByCurrentKey();
                        }
                    } else {
                        this.realData.company_cd = '';
                        this.realData.company_nm = '';
                        clearDependentFields();
                    }
                }
            });
        },
        getCompanyName(data) {
            this.realData.company_nm = data;
        },
        referAreaInfo(index, value) {
            if (!value) {
                this.clearDepartmentInfo();
                this.realData.client_cd = '';
                this.realData.client_nm = '';
                this.clearBranchInfo();
                this.resetDetailBody();
                return;
            }
            this.searchAreaInfo({
                company_cd: this.realData.company_cd ?? 0,
                department_cd: value,
                mode: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        this.realData.mdcd = result.department_cd || result.mdcd || 0;
                        this.realData.md_name = result.department_name || '';
                        this.tryLoadByCurrentKey();
                    } else {
                        this.clearDepartmentInfo();
                        this.realData.client_cd = '';
                        this.realData.client_nm = '';
                        this.clearBranchInfo();
                        this.resetDetailBody();
                    }
                }
            });
        },
        getAreaName(data) {
            this.realData.md_name = data;
        },
        isValidClientCd(value) {
            if (value === null || value === undefined || value === '') return false;
            const clientCd = Number(value);
            return !Number.isNaN(clientCd) && clientCd > 0;
        },
        applyArrayItem(item) {
            if (!item || Object.keys(item).length === 0) return;

            if ((item.mode ?? 1) === 0) {
                this.resetFormData(this.realData.type || '1');
                this.realData.mdcd = item.mdcd || item.department_cd || 0;
                this.realData.md_name = item.md_name || item.supervising_department_name || item.department_name || '';
                if (!this.isCompanyEditable) {
                    this.realData.company_cd = item.company_cd || this.loginCompanyCd || '';
                    this.realData.company_nm = item.company_nm || item.company_name || '';
                } else {
                    this.realData.company_cd = '';
                    this.realData.company_nm = '';
                }
                if (this.realData.company_cd && Number(this.realData.mdcd || 0) > 0) {
                    this.referAreaInfo(0, this.realData.mdcd);
                }
                return;
            }

            this.realData.company_cd = item.company_cd || this.realData.company_cd || '';
            this.realData.company_nm = item.company_nm || item.company_name || this.realData.company_nm || '';
            this.realData.mdcd = item.mdcd || item.department_cd || this.realData.mdcd || 0;
            this.realData.md_name = item.md_name || item.supervising_department_name || item.department_name || this.realData.md_name || '';
            this.realData.client_cd = item.client_cd || item.client_code || this.realData.client_cd || '';
            this.realData.client_nm = item.client_nm || item.client_name || this.realData.client_nm || '';
            this.realData.branch_cd = String(item.branch_cd ?? item.branchCD ?? this.realData.branch_cd ?? '');
            this.realData.branch_nm = item.branch_nm || this.realData.branch_nm || '';

            if (this.isValidClientCd(this.realData.client_cd)) {
                this.tryLoadByCurrentKey();
            }
        },
        mapDataFromApi(clientCd, responseData) {
            const header = responseData?.header || {};
            const schedules = responseData?.schedules || [];
            const visitReports = responseData?.visit_reports || [];
            const paging = responseData?.paging || {};

            this.realData.work_report_id = header.work_report_id || this.realData.work_report_id || 0;
            this.realData.tab_no = header.tab_no || this.realData.tab_no || 1;
            this.realData.company_nm = header.company_nm || this.realData.company_nm || '';
            this.realData.mdcd = header.mdcd || header.department_cd || this.realData.mdcd || 0;
            this.realData.md_name = header.md_name || this.realData.md_name || '';
            this.realData.client_cd = header.client_cd || clientCd || this.realData.client_cd || '';
            this.realData.client_nm = header.customer_name || this.realData.client_nm || '';
            this.realData.branch_cd = String(header.branch_cd ?? this.realData.branch_cd ?? '');
            this.realData.branch_nm = header.branch_nm || this.realData.branch_nm || '';
            this.realData.visit_date = header.visit_date || '';
            this.realData.report_date = header.report_date || '';
            this.realData.report_content = header.report_items_contents1 || header.report_detail || '';
            this.realData.reporting_filename = header.reporting_filename || header.file_path || '';

            const selectedMatters = [];
            for (let i = 1; i <= 8; i++) {
                if (Number(header[`sales_note_chk${i}`]) === 1) selectedMatters.push(String(i));
            }
            this.realData.sales_matter_content = selectedMatters;

            this.realData.purchasing_people = (schedules || []).map((item, index) => ({
                __row_uid: this.generateRowUid('pp'),
                staff_detail_no: item.staff_detail_no || 0,
                no: item.staff_detail_no || index + 1,
                start_date: item.start_date || '',
                person_in_charge: item.staff_name || '',
                filename: item.filename || item.file_path || '',
                file_path: item.file_path || item.filename || '',
                file: '',
                note: item.notes || item.remarks || '',
                showImage: false,
                imageSrc: '#',
                disable: { start_date: false, person_in_charge: false, note: false }
            }));
            if (this.realData.purchasing_people.length === 0) {
                this.realData.purchasing_people = [
                    {
                        __row_uid: this.generateRowUid('pp'),
                        staff_detail_no: 0,
                        no: '',
                        start_date: '',
                        person_in_charge: '',
                        filename: '',
                        file_path: '',
                        file: '',
                        note: '',
                        showImage: false,
                        imageSrc: '#',
                        disable: { start_date: false, person_in_charge: false, note: false }
                    }
                ];
            }

            this.realData.visit_reports = (visitReports || []).map((item) => ({
                visit_date: item.visit_date || '',
                reporter_code: item.reporter_code || '',
                reporter_nm: item.reporter_nm || '',
                business_matter: item.business_matter || '',
                business_note: item.business_note || '',
                business_content: item.business_content || '',
                filename: item.filename || ''
            }));

            this.paginationData.pageNo = parseInt(paging.page || 1);
            this.paginationData.pageSize = parseInt(paging.pageSize || 10);
            this.paginationData.totalRows = parseInt(paging.totalRows || 0);
            this.paginationData.msgNoData = this.paginationData.totalRows === 0 ? '該当するデータが存在しません。' : '';
        },
        referByClientCd(clientCd, companyCd = '') {
            repository
                .getData({
                    company_cd: companyCd || this.realData.company_cd || '',
                    mdcd: parseInt(this.realData.mdcd || 0),
                    client_cd: parseInt(clientCd || 0),
                    branch_cd: parseInt(this.realData.branch_cd || 0),
                    page_no: this.paginationData.pageNo || 1,
                    page_size: this.paginationData.pageSize || 10
                })
                .then((res) => {
                    if (res?.data?.Code !== 200) {
                        this.showModalMessage({
                            type: MSG_TYPE.ERROR,
                            title: MSG_TITLE.E001,
                            content: res?.data?.Message || messages.E999,
                            cancelText: MSG_BUTTON.cancelText,
                            okText: MSG_BUTTON.okText
                        });
                        return;
                    }
                    this.mapDataFromApi(clientCd, res.data.Data || {});
                })
                .catch(() => {
                    this.showModalMessage({
                        type: MSG_TYPE.ERROR,
                        title: MSG_TITLE.E001,
                        content: messages.E999,
                        cancelText: MSG_BUTTON.cancelText,
                        okText: MSG_BUTTON.okText
                    });
                });
        },
        getData() {
            this.tryLoadByCurrentKey();
        },
        changeCurrentPage(data) {
            if (this.localData && this.localData.paginationData) {
                this.localData.paginationData.pageNo = data.currentPage;
                this.localData.paginationData.pageSize = data.perPage;
                return;
            }
            this.paginationData.pageNo = data.currentPage;
            this.paginationData.pageSize = data.perPage;
            this.getData();
        },
        changeCurrentPageTab(data) {
            this.localData.paginationData.pageNo = data.currentPage;
            this.localData.paginationData.pageSize = data.perPage;
            this.searchPastSalesReport({
                body: {
                    company_cd: this.localData.CompanyCD,
                    work_report_id: this.localData.WorkReportID,
                    client_cd: this.localData.ClientCD,
                    branch_cd: this.localData.BranchCD,
                    page_no: data.currentPage,
                    page_size: data.perPage
                },
                callback: (data) => {
                    this.localData.past_sales_records = data;
                }
            });
        },
        addNewSchedule() {
            this.realData.purchasing_people.push({
                __row_uid: this.generateRowUid('pp'),
                staff_detail_no: 0,
                no: Date.now(),
                start_date: '',
                person_in_charge: '',
                filename: '',
                file_path: '',
                file: '',
                note: '',
                showImage: false,
                imageSrc: '#',
                disable: { start_date: false, person_in_charge: false, note: false }
            });
        },
        addNewStaff() {
            this.localData.client_staff.push({
                __row_uid: this.generateRowUid('tab'),
                id: this.localData.id,
                CompanyCD: this.localData.CompanyCD,
                no: Date.now(),
                StartDate: '',
                StaffName: '',
                FilePath: '',
                File: '',
                Remarks: '',
                showImage: false,
                disable: { StartDate: false, StaffName: false, Remarks: false }
            });
        },
        disableField(item, key) {
            if (item[key]) {
                item.disable[key] = true;
            }
        },
        changeType() {
            const keyData = {
                company_cd: this.realData.company_cd,
                company_nm: this.realData.company_nm,
                mdcd: this.realData.mdcd,
                md_name: this.realData.md_name,
                client_cd: this.realData.client_cd,
                client_nm: this.realData.client_nm,
                branch_cd: this.realData.branch_cd,
                branch_nm: this.realData.branch_nm
            };
            this.resetFormData(this.realData.type);
            Object.assign(this.realData, keyData);
        },
        hideDetail() {
            this.$emit('emitHideDetail');
        },
        drafSubmit() {},
        hasInvalidPurchasingPeople() {
            return (this.realData.purchasing_people || []).some((item) => {
                const startDate = item?.start_date ? String(item.start_date).trim() : '';
                const personInCharge = item?.person_in_charge ? String(item.person_in_charge).trim() : '';
                return startDate === '' || personInCharge === '';
            });
        },
        submit() {
            const companyCd = String(this.realData.company_cd || '').trim();
            const clientCd = this.realData.client_cd || '';
            const branchCd = String(this.realData.branch_cd || '').trim();
            if ((this.isCompanyEditable && !companyCd) || !clientCd || !branchCd || Number(this.realData.mdcd || 0) <= 0) {
                return;
            }

            if (this.hasInvalidPurchasingPeople()) {
                return;
            }

            const purchasingPeople = this.realData.purchasing_people || [];
            const usedStaffDetailNos = purchasingPeople.map((item) => Number(item?.staff_detail_no || 0)).filter((no) => no > 0);
            let nextStaffDetailNo = usedStaffDetailNos.length > 0 ? Math.max(...usedStaffDetailNos) + 1 : 1;

            const details = purchasingPeople.map((item) => {
                let staffDetailNo = Number(item.staff_detail_no || 0);
                if (staffDetailNo <= 0) {
                    staffDetailNo = nextStaffDetailNo;
                    nextStaffDetailNo += 1;
                }
                return {
                    staff_detail_no: staffDetailNo,
                    start_date: item.start_date || '',
                    staff_name: item.person_in_charge || '',
                    file_path: item.file_path || item.filename || '',
                    remarks: item.note || ''
                };
            });

            const formData = new FormData();
            formData.append('company_cd', this.realData.company_cd ?? '');
            formData.append('mdcd', this.realData.mdcd || 0);
            formData.append('work_report_id', this.realData.work_report_id || 0);
            formData.append('tab_no', this.realData.tab_no || 1);
            formData.append('client_cd', clientCd);
            formData.append('branch_cd', this.realData.branch_cd || 0);
            formData.append('report_detail', this.realData.report_content || '');
            formData.append('report_items_contents1', this.realData.report_content || '');
            formData.append('file_path', this.realData.reporting_filename || '');
            formData.append('reporting_filename', this.realData.reporting_filename || '');
            formData.append('visit_date', this.realData.visit_date || '');
            formData.append('report_date', this.realData.report_date || '');
            formData.append('business_matters_json', JSON.stringify(this.realData.sales_matter_content || []));
            formData.append('detail_json', JSON.stringify(details));

            if (this.realData.reporting_file && typeof this.realData.reporting_file !== 'string') {
                formData.append('reporting_file', this.realData.reporting_file);
            }

            (this.realData.purchasing_people || []).forEach((item, index) => {
                if (item.file && typeof item.file !== 'string') {
                    formData.append(`detail_files[${index}]`, item.file);
                }
            });

            const isUpdate = (this.realData.purchasing_people || []).some((item) => Number(item?.staff_detail_no || 0) > 0);
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: isUpdate ? MSG_TITLE.C002 : MSG_TITLE.C001,
                content: isUpdate ? messages.C002 : messages.C001,
                cancelText: MSG_BUTTON.cancelText,
                okText: MSG_BUTTON.okText,
                callback: (ok) => {
                    if (!ok) return;
                    repository
                        .storeSave(formData)
                        .then((res) => {
                            if (res?.data?.Code === 200) {
                                const newWorkReportId = res?.data?.Data?.work_report_id ?? 0;
                                if (newWorkReportId) {
                                    this.realData.work_report_id = newWorkReportId;
                                }
                                this.showModalMessage({
                                    type: MSG_TYPE.SUCCESS,
                                    title: isUpdate ? MSG_TITLE.S002 : MSG_TITLE.S001,
                                    content: isUpdate ? messages.S002 : messages.S001,
                                    cancelText: MSG_BUTTON.cancelText,
                                    okText: MSG_BUTTON.okText,
                                    callback: (okSuccess) => {
                                        if (okSuccess) this.hideDetail();
                                    }
                                });
                                return;
                            }
                            this.showModalMessage({
                                type: MSG_TYPE.ERROR,
                                title: MSG_TITLE.E001,
                                content: res?.data?.Message || messages.E999,
                                cancelText: MSG_BUTTON.cancelText,
                                okText: MSG_BUTTON.okText
                            });
                        })
                        .catch(() => {
                            this.showModalMessage({
                                type: MSG_TYPE.ERROR,
                                title: MSG_TITLE.E001,
                                content: messages.E999,
                                cancelText: MSG_BUTTON.cancelText,
                                okText: MSG_BUTTON.okText
                            });
                        });
                }
            });
        },
        openFile(id, index) {
            document.querySelector('#' + id + index).value = '';
            document.querySelector('#' + id + index).click();
        },
        changeFileReport(event) {
            const file = event.target.files[0];
            if (helpers.checkOverMaxFileSize(file)) {
                document.querySelector('#reporting_file').value = '';
                return;
            }
            if (file.type != 'application/pdf') {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E004,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            this.deleteFileReport();
                        }
                    }
                });
                return;
            }
            if (file.name.length > 200) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E007,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            this.deleteFileReport();
                        }
                    }
                });
                return;
            }
            this.realData.reporting_filename = file.name;
            this.realData.reporting_file = file;
        },
        async deleteFile(item) {
            const oldPath = item?.file_path || '';
            if (oldPath) {
                const formData = new FormData();
                formData.append('company_cd', this.realData.company_cd || this.user?.company_cd || '');
                formData.append('status', 12);
                formData.append('old_path', oldPath);
                try {
                    await repository.uploadFileToSharePath(formData);
                } catch (e) {
                    console.log(e);
                }
            }
            item.filename = '';
            item.file_path = '';
            item.file = '';
            if (item.imageSrc && item.imageSrc.startsWith('blob:')) {
                URL.revokeObjectURL(item.imageSrc);
            }
            item.imageSrc = '#';
            item.showImage = false;
        },
        // downloadPurchasingFile(item) {
        //     const fileName = item?.filename || '';
        //     const filePath = item?.file_path || fileName;
        //     if (!fileName || !filePath) return;
        //     helpers.getFileToDownloadSys004({
        //         fileName: fileName,
        //         status: 12,
        //         company_cd: this.data.company_cd
        //     });
        // },
        downloadTabStaffFile(item) {
            const fileName = item?.FilePath || '';
            const filePath = item?.FilePath || '';
            if (!fileName || !filePath) return;
            helpers.getFileToDownloadSys004({
                fileName,
                filePath,
                fileType: 2
            });
        },
        deleteFileReport() {
            this.realData.reporting_filename = '';
            this.realData.reporting_file = '';
        },
        async showImageCard(item) {
            if (this.checkTab != '0') {
                item.showImage = !item.showImage;
                return;
            }
            const fileName = String(item?.filename || '');
            const filePath = String(item?.file_path || '');
            if (!fileName || !filePath) return;

            const lowerName = fileName.toLowerCase();
            const isImage = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/.test(lowerName);
            if (!isImage) {
                // this.downloadPurchasingFile(item);
                return;
            }

            if (item.showImage) {
                item.showImage = false;
                return;
            }

            if (item.imageSrc && item.imageSrc !== '#') {
                item.showImage = true;
                return;
            }

            try {
                const companyCd = this.realData?.company_cd || this.user?.company_cd || '';
                const res = await repository.getImage(filePath, companyCd, 12);
                if (res?.status === 200 && res?.data?.size > 0) {
                    const objectUrl = URL.createObjectURL(res.data);
                    item.imageSrc = objectUrl;
                    item.showImage = true;
                }
            } catch (e) {
                console.log(e);
            }
        },
        async changeFile(event, item, index) {
            const file = event.target.files[0];
            if (!file) return;
            if (helpers.checkOverMaxFileSize(file)) {
                document.querySelector('#business_card' + (index + 1)).value = '';
                return;
            }
            const isPdf = file.type === 'application/pdf';
            const isImage = typeof file.type === 'string' && file.type.startsWith('image/');
            if (!isPdf && !isImage) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: 'PDFまたは画像ファイル（JPG/PNGなど）を選択してください。',
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText
                });
                return;
            }
            if (file.name.length > 200) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E007,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            item.filename = '';
                            item.file = '';
                        }
                    }
                });
                return;
            }
            const oldPath = item?.file_path || '';
            const formData = new FormData();
            formData.append('company_cd', this.realData.company_cd || this.user?.company_cd || '');
            formData.append('status', 12);
            formData.append('file', file);
            if (oldPath) {
                formData.append('old_path', oldPath);
            }

            try {
                const res = await repository.uploadFileToSharePath(formData);
                if (res?.data?.Code === 200) {
                    if (item.imageSrc && item.imageSrc.startsWith('blob:')) {
                        URL.revokeObjectURL(item.imageSrc);
                    }
                    item.filename = res?.data?.Data?.file_name || file.name;
                    item.file_path = res?.data?.Data?.file_path || '';
                    item.file = '';
                    item.imageSrc = '#';
                    item.showImage = false;
                    return;
                }
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: res?.data?.Message || messages.E999,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText
                });
            } catch (e) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E999,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText
                });
            }
        },
        deleteItemTable(index_no, rowKey = '') {
            const isTabMode = this.checkTab != '0' && Array.isArray(this.localData?.client_staff);
            const list = isTabMode ? this.localData.client_staff : this.realData.purchasing_people || [];
            if (!Array.isArray(list) || list.length === 0) return;
            if (list.length === 1) return;
            if (this.isDeleteModalOpening) return;
            this.isDeleteModalOpening = true;
            let isHandled = false;

            const removeRow = () => {
                let targetIndex = index_no;
                if (rowKey) {
                    const foundIndex = list.findIndex((it, idx) => this.getRowKey(it, idx) === rowKey);
                    if (foundIndex >= 0) targetIndex = foundIndex;
                }
                if (targetIndex >= 0 && targetIndex < list.length) {
                    list.splice(targetIndex, 1);
                }
            };

            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C003,
                content: messages.C003,
                cancelText: MSG_BUTTON.cancelText,
                okText: MSG_BUTTON.okText,
                callback: (ok) => {
                    if (isHandled) return;
                    isHandled = true;
                    if (ok) {
                        removeRow();
                        this.selectedIndex = null;
                        this.liftedIndex = null;
                    }
                    this.isDeleteModalOpening = false;
                },
                callbackCancel: (ok) => {
                    if (isHandled) return;
                    isHandled = true;
                    if (ok) {
                        this.selectedIndex = null;
                        this.liftedIndex = null;
                    }
                    this.isDeleteModalOpening = false;
                }
            });
        },
        getRowKey(item, index) {
            const uid = this.ensureRowUid(item, this.checkTab != '0' ? 'tab' : 'pp');
            if (uid) return uid;
            const keyNo = item?.staff_detail_no ?? item?.no ?? item?.StaffDetailNo ?? item?.No;
            if (keyNo !== null && keyNo !== undefined && keyNo !== '') return `k_${keyNo}`;
            return `i_${index}`;
        },
        startHold(e, index, item) {
            const now = Date.now();
            if (e?.type === 'touchstart') {
                this.lastTouchStartAt = now;
                this.isTouchInteraction = true;
            }
            if (e?.type === 'mousedown' && (this.isTouchInteraction || now - this.lastTouchStartAt < 1000)) {
                return true;
            }
            const tag = e.target.tagName.toLowerCase();
            if (['input', 'select', 'textarea', 'button', 'label'].includes(tag)) {
                return true;
            }
            const rowKey = this.getRowKey(item, index);
            clearTimeout(this.holdTimer);
            clearTimeout(this.deleteTimer);
            this.holdTimer = setTimeout(() => {
                this.liftedIndex = index;
            }, 300);

            this.deleteTimer = setTimeout(() => {
                this.selectedIndex = index;
                this.deleteItemTable(index, rowKey);
            }, 800);
        },
        cancelHold() {
            clearTimeout(this.holdTimer);
            clearTimeout(this.deleteTimer);
            this.liftedIndex = null;
            if (this.isTouchInteraction) {
                setTimeout(() => {
                    this.isTouchInteraction = false;
                }, 800);
            }
        },
        referClientInfo(index, value) {
            if (!value) {
                this.realData.client_cd = '';
                this.realData.client_nm = '';
                this.realData.mdcd = 0;
                this.clearBranchInfo();
                this.resetDetailBody();
                return;
            }
            this.searchMst001Info({
                company_cd: this.realData.company_cd ?? '',
                customer_cd: value || 0,
                pageNo: 1,
                pageSize: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        this.realData.client_cd = result.customer_cd;
                        this.realData.client_nm = result.customer_name;
                        this.realData.mdcd = result.mdcd ?? result.department_cd ?? this.realData.mdcd ?? 0;
                        this.clearBranchInfo();
                        this.resetDetailBody();
                    } else {
                        this.realData.client_cd = '';
                        this.realData.client_nm = '';
                        this.realData.mdcd = 0;
                        this.clearBranchInfo();
                        this.resetDetailBody();
                    }
                },
                onError: (error) => {
                    console.log(error);
                }
            });
        },
        getClientName(data) {
            this.realData.client_nm = data;
            const selectedClientCd = String(this.realData.client_cd || '');
            if (selectedClientCd) {
                this.referClientInfo(0, selectedClientCd);
            }
        },
        referBranchInfo(index, value) {
            if (!value) {
                this.clearBranchInfo();
                this.resetDetailBody();
                return;
            }
            this.searchMst002Info({
                company_cd: this.realData.company_cd ?? '',
                customer_cd: this.realData.client_cd ?? '',
                mdcd: this.realData.mdcd ?? 0,
                location_cd: value || 0,
                pageNo: 1,
                pageSize: 1,
                mode: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        this.realData.branch_cd = String(result.kyoten_cd ?? result.location_cd ?? '');
                        this.realData.branch_nm = result.kyoten_name ?? result.location_name ?? '';
                        this.tryLoadByCurrentKey();
                    } else {
                        this.clearBranchInfo();
                        this.resetDetailBody();
                    }
                }
            });
        },
        getBranchName(data) {
            this.realData.branch_nm = data;
        },
        changeFileTabSale(event) {
            const file = event.target.files[0];
            if (helpers.checkOverMaxFileSize(file)) {
                document.querySelector('#reporting_tab_sale').value = '';
                return;
            }
            if (file.type != 'application/pdf') {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E004,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            this.deleteFileTabSale();
                        }
                    }
                });
                return;
            }
            if (file.name.length > 200) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E007,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            this.deleteFileTabSale();
                        }
                    }
                });
                return;
            }
            const filename = file.name;
            this.localData.FilePath = filename;
            this.localData.File = file;
        },
        deleteFileTabSale() {
            this.localData.FilePath = '';
            this.localData.File = '';
        },
        changeFileStaffCard(event, item, index) {
            const file = event.target.files[0];
            if (helpers.checkOverMaxFileSize(file)) {
                document.querySelector('#staff_business_card' + this.tabId + (index + 1)).value = '';
                return;
            }
            if (!file.type.startsWith('image/')) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: '画像ファイル（JPG/PNG）を選択してください。',
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            item.FilePath = '';
                            item.File = '';
                        }
                    }
                });
                return;
            }
            if (file.name.length > 200) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E007,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            item.FilePath = '';
                            item.File = '';
                        }
                    }
                });
                return;
            }
            const filename = file.name;
            item.FilePath = filename;
            item.File = file;
            // Preview image
            const reader = new FileReader();
            reader.onload = (e) => {
                const base64 = e.target.result;

                item.imageSrc = base64;
                item.showImage = true;
                item.hasImage = true;

                this.$nextTick(() => {
                    const img = this.$refs[`imagePreview_${index}`];
                    if (img) {
                        img.onerror = () => {
                            item.showImage = false;
                        };
                        img.src = base64;
                    }
                });
            };

            reader.readAsDataURL(file);
        },
        deleteFileStaffCard(item) {
            item.FilePath = '';
            item.File = '';
        },
        getClientNameTab(data) {
            this.localData.ClientName = data;
            this.localData.BranchCD = '';
            this.localData.BranchName = '';
        },
        referClient(index, value) {
            if (!value) {
                this.localData.ClientCD = '';
                this.localData.ClientName = '';
                this.localData.BranchCD = '';
                this.localData.BranchName = '';
                return;
            }
            this.searchMst001Info({
                company_cd: this.localData.CompanyCD ?? '',
                customer_cd: value || 0,
                pageNo: 1,
                pageSize: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        this.localData.ClientCD = result.customer_cd;
                        this.localData.ClientName = result.customer_name;
                    } else {
                        this.localData.ClientCD = '';
                        this.localData.ClientName = '';
                    }
                    this.localData.BranchCD = '';
                    this.localData.BranchName = '';
                }
            });
        },
        getBranch(data) {
            this.localData.BranchName = data;
        },
        referBranchCD(index, value) {
            if (!value) {
                this.localData.BranchCD = '';
                this.localData.BranchName = '';
                return;
            }
            this.searchMst002Info({
                company_cd: this.localData.CompanyCD ?? this.user?.company_cd ?? '',
                customer_cd: this.localData.ClientCD ?? 0,
                mdcd: this.localData.MDCD ?? 0,
                location_cd: value || 0,
                mode: 1,
                pageNo: 1,
                pageSize: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        this.localData.BranchCD = result.location_cd;
                        this.localData.BranchName = result.location_name;
                    } else {
                        this.localData.BranchCD = '';
                        this.localData.BranchName = '';
                    }
                }
            });
        }
    }
};
export default APP_SalesReport002;
</script>
